import { apiRequest } from '../api/client';
import type { StaffRole } from './session';

export interface StaffLoginRequest {
  username: string;
  password: string;
  /** `admin` = TTL Admin Web. Staff App gửi `staff`. */
  client: 'admin' | 'staff';
}

/**
 * Đăng nhập KHÔNG mở ca làm (đổi ở `S1-BE-07`) — mở ca là bước riêng trên Staff App.
 * Admin Web không mở ca bao giờ, nên ở đây token không có `shift_id` là đúng.
 */
export interface StaffLoginResponse {
  staffId: string;
  name: string;
  role: StaffRole;
  /** Chi nhánh cố định của nhân viên; `null` với tài khoản HQ */
  branchId: string | null;
  mustChangePassword: boolean;
  accessToken: string;
  accessTokenExpiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
}

export interface CurrentStaffResponse {
  staffId: string;
  username: string;
  name: string;
  role: StaffRole;
  branchId: string | null;
  activeShift: { shiftId: string; branchId: string; shiftLabel: string; startedAt: string } | null;
}

export interface RefreshResponse {
  accessToken: string;
  accessTokenExpiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
}

export async function staffLogin(body: StaffLoginRequest): Promise<StaffLoginResponse> {
  const envelope = await apiRequest<StaffLoginResponse>('/auth/staff/login', {
    method: 'POST',
    body,
    skipAuth: true,
  });
  return envelope.data;
}

export async function refreshSession(refreshToken: string): Promise<RefreshResponse> {
  const envelope = await apiRequest<RefreshResponse>('/auth/refresh', {
    method: 'POST',
    body: { refreshToken },
    skipAuth: true,
  });
  return envelope.data;
}

export async function fetchCurrentStaff(): Promise<CurrentStaffResponse> {
  const envelope = await apiRequest<CurrentStaffResponse>('/auth/staff/me');
  return envelope.data;
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiRequest('/auth/staff/change-password', {
    method: 'POST',
    body: { currentPassword, newPassword },
  });
}
